import { useCallback } from 'react';

import type { FeedbackPeakAnalysisOptions } from '@/features/Feedback/components/FeedbackListModal/peak-analysis';
import useWordCloudFeedbackListModal from '@/features/WordCloud/hooks/useWordCloudFeedbackListModal';
import type { WordCloudBasis } from '@/features/WordCloud/types';

type ChartWordCloudClickParams = {
  keyword: string;
  filter: StructuredFilter;
  translatedKeyword?: string;
  basis?: WordCloudBasis;
  peakAnalysis?: FeedbackPeakAnalysisOptions;
};

export const useOpenChartWordCloudClickDialog = () => {
  const openWordCloudFeedbackListModal = useWordCloudFeedbackListModal();

  return useCallback(
    (params: ChartWordCloudClickParams) => {
      openWordCloudFeedbackListModal(params);
    },
    [openWordCloudFeedbackListModal],
  );
};
